import React from "react";
import { Link } from "react-router";
import { ZOOM_ICON } from "js/config.jsx";
import { Nav, Navbar, NavItem, NavDropdown, MenuItem } from "react-bootstrap";

export default React.createClass({

  render: function() {
    if (FN_MODE !== "qa") {
      var terms = `https://dev.facetec.com/policies/terms.html`
      var privacy_site = `https://dev.facetec.com/policies/privacy_site.html`
      var privacy_sdk = `https://dev.facetec.com/policies/privacy_sdk.html`
    }
    else {
      var terms = `https://dev.facetec.com/policies/terms.html`
      var privacy_site = `https://dev.facetec.com/policies/privacy_site.html`
      var privacy_sdk = `https://dev.facetec.com/policies/privacy_sdk.html`
    }
    return (
      <footer id="footer">
        <span>
          <p>&copy; {(new Date()).getFullYear()} FaceTec, Inc. &thinsp;&middot;&thinsp; Multiple US & International Patents Granted &thinsp;&middot;&thinsp; All Rights Reserved</p>
          <p style={{fontSize:"0.8em"}}><a href={terms} target="_blank">Terms &amp; Conditions</a>&thinsp;&middot;&thinsp; <a href={privacy_site} target="_blank">Site Privacy Policy</a>&thinsp;&middot;&thinsp; <a href={privacy_sdk} target="_blank">SDK Privacy Policy</a></p>
        </span>
      </footer>

    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/sdk-footer.jsx